import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submit", "warning", "moreInfo"]
  static values = { noGoFields: String }

  connect() {
    this.noGoFieldNames = this.noGoFieldsValue?.split(",") || []
  }

  check() {
    this.toggleWarning(this.hasNoGoAnswer())
    this.toggleMoreInfoSections()
  }

  validate(event) {
    let hasErrors = false
    this.clearValidity()

    const reason = this.element.querySelector('textarea[name*="[reason_for_scan]"]')
    if (!reason || !reason.value.trim()) {
      reason.setCustomValidity("Please provide a reason for the scan.")
      reason.reportValidity()
      reason.scrollIntoView({ behavior: "smooth", block: "center" })

      hasErrors = true
    }

    if (!hasErrors) {
      const groups = this.getAllRadioGroups()
      for (const field of groups) {
        const radios = this.getRadioGroup(field)
        const checked = radios.some(r => r.checked)

        const errorTarget = this.element.querySelector(`[data-error-for="${field}"]`)
        if (!checked && errorTarget) {
          errorTarget.textContent = "Please select an option."
          errorTarget.classList.remove("hidden")
          errorTarget.scrollIntoView({ behavior: "smooth", block: "center" })

          hasErrors = true
          break
        }
      }
    }

    if (!hasErrors) {
      for (const target of this.moreInfoTargets) {
        if (!target.classList.contains("hidden")) {
          const textarea = target.querySelector("textarea")
          if (!textarea || !textarea.value.trim()) {
            textarea.setCustomValidity("This field is required.")
            textarea.reportValidity()
            textarea.scrollIntoView({ behavior: "smooth", block: "center" })

            hasErrors = true
            break
          }
        }
      }
    }

    if (this.hasNoGoAnswer()) {
      this.toggleWarning(true)
      this.warningTarget.scrollIntoView({ behavior: "smooth", block: "center" })

      hasErrors = true
    }

    if (hasErrors) {
      event.preventDefault()
      event.stopImmediatePropagation()
    }
  }

  clearValidity() {
    this.element.querySelectorAll("input, textarea").forEach(el => {
      el.setCustomValidity("")
    })
    this.element.querySelectorAll("[data-error-for]").forEach(el => {
      el.textContent = ""
      el.classList.add("hidden")
    })
  }

  getAllRadioGroups() {
    const fields = new Set()
    this.element.querySelectorAll('input[type="radio"]').forEach(el => {
      const match = el.name.match(/\[([^\]]+)\]$/)

      if (match) fields.add(match[1])
    })
    return Array.from(fields)
  }

  getRadioGroup(field) {
    return Array.from(this.element.querySelectorAll(`input[type="radio"][name*="[${field}]"]`))
  }

  getSelectedValue(field) {
    return this.getRadioGroup(field).find(r => r.checked)?.value
  }

  hasNoGoAnswer() {
    return this.noGoFieldNames.some(
      field => this.getSelectedValue(field) === "true"
    )
  }

  toggleWarning(show) {
    this.warningTarget.classList.toggle("hidden", !show)
    this.submitTarget.disabled = show
  }

  toggleMoreInfoSections() {
    this.moreInfoTargets.forEach((target) => {
      const field = target.dataset.field;
      const selected = this.getSelectedValue(field);

      target.classList.toggle("hidden", selected !== "true")
    })
  }
}
